<template>
   <v-container>
      <h1 class="mb-5 text-h5 text-center text--secondary mt-16">
         Pesquisar conversas
      </h1>

      <v-form
         @submit.prevent="search"
         class="mx-auto"
      >
         <v-text-field
            autofocus
            class="query"
            filled
            hide-details
            placeholder="Informe o telefone"
            required
            solo
            v-mask="'(##) #####-####'"
            v-model="query"
         >
            <template v-slot:append-outer>
               <v-btn
                  :disabled="!query"
                  fab color="primary"
                  small
                  type="submit"
               >
                  <v-icon>search</v-icon>
               </v-btn>
            </template>
         </v-text-field>
      </v-form>

      <div
         v-if="searching"
         class="text-center mt-8"
      >
         <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div
         v-if="!searching"
         class="sessions"
      >
         <div
            v-if="result?.count"
            class="text--secondary my-4"
         >
            {{ result.count }}
            {{ result.count > 1 ? 'conversas' : 'conversa' }}
         </div>

         <v-card
            v-if="result?.count"
         >
            <v-list
               two-line
               class="pa-0"
            >
               <template
                  v-for="(session, index) in result.sessions"
               >
                  <v-list-item
                     :key="session.id"
                     :to="`/customerService2/${session.service.id}/conversation/${session.id}`"
                  >
                     <v-tooltip
                        bottom
                     >
                        <template
                           v-slot:activator="{ on }"
                        >
                           <v-list-item-avatar
                              v-on="on"
                           >
                              <v-img
                                 v-if="session.user"
                                 :src="session.user.profile_photo_url || '/img/default.png'"
                              ></v-img>
                              <v-icon v-else>chat</v-icon>
                           </v-list-item-avatar>
                        </template>
                        <span>{{ session.user?.name || 'Sem atendente' }}</span>
                     </v-tooltip>

                     <v-list-item-content>
                        <v-list-item-title>
                           {{ session.service.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                           v-if="session.status != 'AUTO'"
                        >
                           {{ session.status | conversationStatus }}
                        </v-list-item-subtitle>
                     </v-list-item-content>

                     <v-list-item-action>
                        <v-list-item-action-text>
                           <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">{{ session.created_at | moment('from') }}</span>
                              </template>
                              <span>{{ session.updated_at | moment("D/MM/YYYY HH:mm:ss") }}</span>
                           </v-tooltip>
                        </v-list-item-action-text>
                     </v-list-item-action>
                  </v-list-item>

                  <v-divider
                     v-if="index < result.sessions.length - 1"
                     :key="index"
                  ></v-divider>
               </template>
            </v-list>
         </v-card>

         <div
            v-if="result?.sessions?.length === 0"
            class="mt-4 text-center text-h6 text--secondary"
         >
            Nenhuma conversa encontrada
         </div>
      </div>

      <v-alert
         class="mt-4 mx-auto text-center"
         max-width="400"
         text
         type="error"
         v-if="error"
      >
         Não foi possível pesquisar
      </v-alert> 
   </v-container>
</template>

<script>
import SessionsService from '@/services/sessions';

export default {
   data() {
      return {
         error: false,
         query: null,
         result: null,
         searching: false,
      };
   },

   created() {
      this.query = this.$route.query.q || null;

      if (this.query) {
         this.search();
      }
   },

   methods: {
      async search() {
         if (!this.query) {
            return;
         }

         let query = this.query.replace(/\D/g, '');
         this.$router.replace({ query: { q: query } });

         this.error = false;
         this.result = null;
         this.searching = true;

         let params = {
            order: '-created_at',
            sender: this.query,
         };

         try {
            let response = await SessionsService.get_sessions_by_params(params);
            this.result = response.data;
         } catch (error) {
            this.error = true;
         } finally {
            this.searching = false;
         }
      },
   },
};
</script>

<style lang="scss">
form {
   max-width: 400px;

   .query {
      input {
         text-align: center;
      }
   }

   ::placeholder {
      text-align: center;
   }
}

.sessions {
   max-width: 400px;
   margin: auto;
}
</style>
